import { render, staticRenderFns } from "./update.template.pug?vue&type=template&id=5e6b9de4&lang=pug&"
import script from "./update.script.js?vue&type=script&lang=js&"
export * from "./update.script.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "index.vue"
export default component.exports